import { render } from "./Login.vue?vue&type=template&id=12bd602f&scoped=true"
const script = {}

import "./Login.vue?vue&type=style&index=0&id=12bd602f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-12bd602f"

export default script